import { useState } from "react";
import { Ellipsis, Pencil, Trash2 } from "lucide-react";
import { toast } from "sonner";

import { buttonVariants } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import ACL_RELATIONSHIPS from "acl-relationships";
import { checkIsAuthorized } from "components/helpers";
import ConfirmDeleteDialog from "components/modals/ConfirmDeleteDialog";
import FormDialog from "components/modals/FormDialog";
import {
  deleteRecipient,
  invalidateRecipientsQuery,
} from "hooks/useRecipientsTable";
import RecipientForm from "routes/recipients/RecipientForm";

export function RecipientsTableActions({ original }) {
  const [editOpen, setEditOpen] = useState(false);
  const [deleteOpen, setDeleteOpen] = useState(false);

  const canEdit = checkIsAuthorized([ACL_RELATIONSHIPS.recipient.edit]);
  const canDelete = checkIsAuthorized([ACL_RELATIONSHIPS.recipient.delete]);

  const handleDelete = async () => {
    try {
      await deleteRecipient(original.id);
      toast.success("Recipient deleted");
      setDeleteOpen(false);
    } catch {
      toast.error("Failed to delete recipient");
    }
  };

  if (!canEdit && !canDelete) return null;

  return (
    <>
      <DropdownMenu>
        <DropdownMenuTrigger
          aria-label="Recipient actions"
          className={buttonVariants({ variant: "ghost", size: "icon-sm" })}
        >
          <Ellipsis />
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end">
          {canEdit && (
            <DropdownMenuItem onClick={() => setEditOpen(true)}>
              <Pencil />
              Edit
            </DropdownMenuItem>
          )}
          {canDelete && (
            <DropdownMenuItem
              variant="destructive"
              onClick={() => setDeleteOpen(true)}
            >
              <Trash2 />
              Delete
            </DropdownMenuItem>
          )}
        </DropdownMenuContent>
      </DropdownMenu>
      <FormDialog
        FormComponent={RecipientForm}
        model={original}
        modelType="Recipient"
        open={editOpen}
        onOpenChange={setEditOpen}
        onSuccess={invalidateRecipientsQuery}
      />
      <ConfirmDeleteDialog
        open={deleteOpen}
        onOpenChange={setDeleteOpen}
        title="Delete recipient?"
        description="Are you sure you want to delete this Recipient?"
        onConfirm={handleDelete}
      />
    </>
  );
}
